var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "form-content", attrs: { id: "wizard-step-2" } },
    [
      _c("sc-form", {
        attrs: { form: _vm.formContent, "has-style": false },
        on: {
          submit: function(val) {
            return _vm.$emit("onNextStep", val)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "fields",
            fn: function(ref) {
              var fields = ref.fields
              return [
                _c(
                  "section",
                  { staticClass: "upload-form" },
                  [
                    _c(
                      "sc-field",
                      {
                        staticClass: "upload-form__step",
                        attrs: { id: "template-step-4", prop: "rowNumber" }
                      },
                      [
                        _c(
                          "template",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _c(
                              "span",
                              { staticClass: "upload-form__step__label" },
                              [
                                _c(
                                  "sc-tag",
                                  { attrs: { size: "is-medium", rounded: "" } },
                                  [_vm._v("4")]
                                ),
                                _vm._v(
                                  "\n              Linha do cabeçalho\n              "
                                ),
                                _c("p", { staticClass: "additional-label" }, [
                                  _vm._v(
                                    "Digite o número da linha onde está localizado o cabeçalho da planilha da fatura"
                                  )
                                ])
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("sc-input", {
                          staticStyle: { width: "66px" },
                          attrs: {
                            size: "is-medium",
                            type: "number",
                            min: "1",
                            id: "rowNumber"
                          },
                          nativeOn: {
                            keydown: function($event) {
                              $event.preventDefault()
                            }
                          },
                          model: {
                            value: fields.rowNumber,
                            callback: function($$v) {
                              _vm.$set(fields, "rowNumber", $$v)
                            },
                            expression: "fields.rowNumber"
                          }
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "upload-form__step" },
                      [_c("new-billing-template-image-helper")],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "actions",
            fn: function(ref) {
              var isValid = ref.isValid
              return [
                _c("section", { staticClass: "continue-buttom" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.$emit("onPrevStep")
                        }
                      }
                    },
                    [_vm._v("Voltar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      attrs: { type: "submit" }
                    },
                    [_vm._v("Continuar")]
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2713fe24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2713fe24","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/NewBillingTemplateStep2.vue
// module id = null
// module chunks = 